export const ivfTemplates = [
  {
    name: "הסכמה לטיפולי הפרייה חוץ גופית",
    key: "ba96a47d-f562-4978-ac7e-3f9647f202f6"
  },
  {
    name: "הסכמה לטיפולי הפרייה + שימור ביציות מופרות מוקפאות",
    key: "daf4ac41-5f6c-4ad0-89b6-42a7696d7bf8"
  },
  {
    name: "הסכמה לטיפולי הפרייה + הקפאת ביציות",
    key: "14fe96e5-bab0-494d-aaff-69299bc6855e"
  },
  {
    name: "הסכמה לקבלת הוראה טלפונית",
    key: "427e906c-8233-47c5-8e4f-ee029e24a36f"
  },
  {
    name: "ייפוי כוח להחזרת עוברים לרחם",
    key: "de074f89-cda3-48ae-b01c-930681b59a6c"
  },
  {
    name: "הסכמה ל PGT-A",
    key: "9859898e-0a85-4138-8f9d-bdcaabe3086f"
  },
  {
    name: "טיפול עם סיכויי הצלחה קלושים",
    key: "16322c8a-556c-4a03-b864-69a5f8dc376f"
  },
  {
    name: "הפרייה חוץ גופית לאישה מתרומת ביציות",
    key: "83612ff5-95d6-45b6-b543-bff273491305"
  },
  {
    name: "הצהרה על מצב בריאותי והסכמה להמשך טיפולי הפריה חוץ גופית",
    key: "76c7e359-a0b9-4641-9f53-0c5b3508431a"
  },
  {
    name: "הזרעה מלאכותית עם זרע של תורם לאישה פנויה",
    key: "ecdd6cb0-3982-41fa-bacd-d3e26096741d"
  },
  {
    name: "הזרעה מלאכותית מזרע תורם אצל זוג נשוי",
    key: "0c40fcd5-6777-4947-a3e1-87eeb15ecf4c"
  },
  {
    name: "הקפאת ביציות",
    key: "59257a57-6b03-4161-ae2f-0fa174809e19"
  },
  {
    name: "הסכמה לשימור ביציות מופרות מוקפאות",
    key: "191eb558-9d72-4f9b-b4ae-da31ccc8a81b"
  },
  {
    name: "הסכמה מדעת PGD",
    key: "f12777b2-c35b-42d6-ae31-a5316f46afbd"
  },
  {
    name: "החזרת עוברים מתרומת ביצית לאחר ביצוע בדיקות גנטיות",
    key: "8bd89d4e-3f07-466b-89ff-8370144b61ad"
  }
];
